import store from '@/store'
import CrudAPI from '@/api/resources/crud'

const invoiceAPI = {
  resource: 'invoices',

  markPaid (itemId) {
    return new Promise((resolve, reject) => {
      let payload = {
        status: 'paid'
      }

      let result = CrudAPI.dfsResourceUpdate(this.resource, itemId, payload)

      result.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  uploadInvoice (formData, caseId) {
    let url = store.getters.config.api_host + '/api/cases/' + caseId + '/upload_invoice'

    let config = {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    }

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url, formData, config).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default invoiceAPI



// WEBPACK FOOTER //
// ./src/api/invoice.js